const t = {
  "lead-text": "lead-text"
};
export {
  t as default
};
